import React from "react";
import {Modal} from 'react-bootstrap';
import { useDispatch } from "react-redux";
const MediumModal = (props) => {
  const { children, header, show, closeFunction, className } = props;
  const dispatch = useDispatch();
  return (
    <Modal
      show={show}
      onHide={() => dispatch(closeFunction())}
      size="md"
      className={className ? className : ""}
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter custom-modal-title">
          {header}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          {children}
      </Modal.Body>
    </Modal>
  );
};

export default MediumModal;
